import clsx from "clsx";
import styles from "./CircledInitials.module.scss";
import { getInitials } from "./initialsUtils";

const CircledInitials = ({
  name,
  size = "small",
}: {
  name: string;
  size?: "small" | "medium" | "large";
}) => {
  const initials = getInitials(name);

  return (
    <div className={clsx(styles.circle, styles[size])}>
      <span className={styles.initials} data-initials-count={initials.length}>
        {initials}
      </span>
    </div>
  );
};

export default CircledInitials;
